/********************************************************************
*                                                                   *
*   This file contains the styles for the flowbite components       *
*   if you want to modify any styles, check flowbite documentation  *
*                                                                   *
*********************************************************************/


// Styles for Date Picker
export const datePickerTheme = {
    datepicker: {
        root: {
            input: {
                field: {
                    input: {
                        base: "shadow w-full border border-gray-90"
                    }
                }
            }
        },
        popup: {
            footer: {
                button: {
                    today: "bg-black text-white hover:bg-white hover:text-black hover:border-2 hover:border-black dark:bg-cyan-600 dark:hover:bg-cyan-700",                
                }
            }
        },
        views :{
            days: {
                items: {
                    item: {
                        selected: "bg-black text-white hover:bg-cyan-600",
                    }
                }
            },
            months: {
                items: {
                    item: {
                        selected: "bg-black text-white hover:bg-black",
                    }
                }
            },
            years: {
                items: {
                    item: {
                        selected: "bg-black text-white hover:bg-black",
                    }
                }
            }
        },
        
    }
}

export const dropDownTheme = {
   
    button: {        
       base: "z-10 rounded divide-y divide-gray-100 shadow focus:outline-none bg-gray-50 border-gray-300 block w-full   text-gray-900 border"   
    },
   
}

export const buttonTheme = {
    button: {
        color: {
            primary:"bg-black text-white w-fit",
            secondary:"text-gray-900 bg-white border border-gray-200 enabled:hover:bg-gray-100 enabled:hover:text-black :ring-cyan-700 focus:text-cyan-700 dark:bg-transparent dark:text-gray-400 dark:border-gray-600 dark:enabled:hover:text-white dark:enabled:hover:bg-gray-700 focus:ring-2",
        } , 
        
    }
}

export const inputFileTheme = {
    fileInput: {
        field: {
           
            input: {
                
                
            }
        },
      
    },


} 


export const centerText = {  
       textInput : {
        
            field: {
                     
                input: {
                    base:"w-[50px] text-center ",
                    colors:{
                        primary:"placeholder-black"
                    }
                    
                }
            }
            
       }
   
    
}

export const timeLineTheme = {
    timeline: {
        item: {
            root: {
                vertical:"mb-5 ml-6"
            },
            point: {
                marker: {
                    icon: {
                        base:"h-3 w-3 text-black dark:text-cyan-300",
                        wrapper: "absolute -left-3 flex h-6 w-6 items-center justify-center rounded-full bg-gray-200 ring-8 ring-white dark:bg-cyan-900 dark:ring-gray-900"
                    }
                }
            }
        }
    }
}